[
  {
    "key": "agriculture",
    "name": "Agriculture",
    "era": "ancient",
    "requires": [],
    "description": "Seed kept back from one harvest and sown for the next. The first surplus, and everything that grows from it."
  },
  {
    "key": "husbandry",
    "name": "Animal Husbandry",
    "era": "ancient",
    "requires": [],
    "description": "Herds kept rather than hunted: meat, milk, hides and, in time, something to ride."
  },
  {
    "key": "stoneworking",
    "name": "Stoneworking",
    "era": "ancient",
    "requires": [],
    "description": "Flint shaped, stone dressed, ground levelled. The oldest craft there is."
  },
  {
    "key": "pottery",
    "name": "Pottery",
    "era": "ancient",
    "requires": [],
    "description": "Clay fired hard enough to hold grain through a winter and oil across a sea."
  },
  {
    "key": "ritual",
    "name": "Ritual",
    "era": "ancient",
    "requires": [],
    "description": "Shared rites for the dead and the seasons — the first thing a people agrees on."
  },
  {
    "key": "woodworking",
    "name": "Woodworking",
    "era": "ancient",
    "requires": [],
    "description": "Timber split, joined and bent to purpose: shelters, handles, hulls."
  },
  {
    "key": "irrigation",
    "name": "Irrigation",
    "era": "ancient",
    "requires": [
      "agriculture"
    ],
    "description": "Water led where it is wanted. Dry ground becomes field."
  },
  {
    "key": "herbal_lore",
    "name": "Herbal Lore",
    "era": "ancient",
    "requires": [
      "agriculture"
    ],
    "description": "Which plants heal, which poison, and when to gather them."
  },
  {
    "key": "horseback_riding",
    "name": "Horseback Riding",
    "era": "ancient",
    "requires": [
      "husbandry"
    ],
    "description": "A rider covers in a day what a walker covers in three."
  },
  {
    "key": "bronze_working",
    "name": "Bronze Working",
    "era": "ancient",
    "requires": [
      "stoneworking"
    ],
    "description": "Copper and tin smelted together into the first metal worth an army."
  },
  {
    "key": "archery",
    "name": "Archery",
    "era": "ancient",
    "requires": [
      "woodworking"
    ],
    "description": "A bent stave and a string: death at a distance."
  },
  {
    "key": "boatbuilding",
    "name": "Boatbuilding",
    "era": "ancient",
    "requires": [
      "woodworking"
    ],
    "description": "Planked hulls for rivers and the calm water within sight of shore."
  },
  {
    "key": "the_wheel",
    "name": "The Wheel",
    "era": "ancient",
    "requires": [
      "woodworking",
      "husbandry"
    ],
    "description": "Carts, then chariots, then everything that rolls."
  },
  {
    "key": "writing",
    "name": "Writing",
    "era": "ancient",
    "requires": [
      "pottery",
      "ritual"
    ],
    "description": "Tallies scratched on clay become words. Memory no longer dies with the rememberer."
  },
  {
    "key": "calendar",
    "name": "Calendar",
    "era": "ancient",
    "requires": [
      "agriculture",
      "ritual"
    ],
    "description": "The year counted and divided, so that sowing is never too early or too late."
  },
  {
    "key": "iron_working",
    "name": "Iron Working",
    "era": "ancient",
    "requires": [
      "bronze_working"
    ],
    "description": "Harder to smelt than bronze, but found almost everywhere."
  },
  {
    "key": "masonry",
    "name": "Masonry",
    "era": "ancient",
    "requires": [
      "bronze_working"
    ],
    "description": "Cut stone laid in courses: walls, granaries, tombs that outlast their builders."
  },
  {
    "key": "currency",
    "name": "Currency",
    "era": "ancient",
    "requires": [
      "bronze_working",
      "pottery"
    ],
    "description": "Metal of agreed weight, stamped so nobody need weigh it again."
  },
  {
    "key": "code_of_laws",
    "name": "Code of Laws",
    "era": "ancient",
    "requires": [
      "writing"
    ],
    "description": "Rules written where anyone can read them, and so applied to everyone."
  },
  {
    "key": "mathematics",
    "name": "Mathematics",
    "era": "ancient",
    "requires": [
      "writing",
      "calendar"
    ],
    "description": "Numbers for their own sake, and then for everything else."
  },
  {
    "key": "priesthood",
    "name": "Priesthood",
    "era": "ancient",
    "requires": [
      "ritual",
      "writing"
    ],
    "description": "Keepers of rite and record, with land, temples and influence of their own."
  },
  {
    "key": "chariotry",
    "name": "Chariotry",
    "era": "ancient",
    "requires": [
      "the_wheel",
      "horseback_riding"
    ],
    "description": "Two horses and a platform: the first war machine."
  },
  {
    "key": "seafaring",
    "name": "Seafaring",
    "era": "ancient",
    "requires": [
      "boatbuilding",
      "calendar"
    ],
    "description": "Sailing by the stars and the seasons, out of sight of land and back again."
  },
  {
    "key": "kingship",
    "name": "Kingship",
    "era": "ancient",
    "requires": [
      "code_of_laws",
      "priesthood"
    ],
    "description": "One ruler, sanctioned by the gods, succeeded by an heir."
  },
  {
    "key": "literacy",
    "name": "Literacy",
    "era": "classical",
    "requires": [
      "writing",
      "code_of_laws"
    ],
    "description": "Reading spreads beyond the scribes. Clerks, then scholars, then libraries."
  },
  {
    "key": "astronomy",
    "name": "Astronomy",
    "era": "classical",
    "requires": [
      "mathematics",
      "priesthood"
    ],
    "description": "The heavens charted and their motions predicted."
  },
  {
    "key": "standing_army",
    "name": "Standing Army",
    "era": "classical",
    "requires": [
      "iron_working",
      "code_of_laws"
    ],
    "description": "Soldiers paid, drilled and kept under arms in peace as well as war."
  },
  {
    "key": "surveying",
    "name": "Surveying",
    "era": "classical",
    "requires": [
      "mathematics",
      "the_wheel"
    ],
    "description": "Land measured, bounded and recorded — and roads laid straight across it."
  },
  {
    "key": "construction",
    "name": "Construction",
    "era": "classical",
    "requires": [
      "masonry",
      "mathematics"
    ],
    "description": "Mortar, arches and scaffolding: buildings larger than anyone had dared."
  },
  {
    "key": "cartography",
    "name": "Cartography",
    "era": "classical",
    "requires": [
      "seafaring",
      "writing"
    ],
    "description": "Coasts and routes drawn so the next captain need not rediscover them."
  },
  {
    "key": "glassmaking",
    "name": "Glassmaking",
    "era": "classical",
    "requires": [
      "pottery",
      "construction"
    ],
    "description": "Sand, fire and patience: vessels, beads and, much later, lenses."
  },
  {
    "key": "philosophy",
    "name": "Philosophy",
    "era": "classical",
    "requires": [
      "priesthood",
      "literacy"
    ],
    "description": "Questions asked for the sake of the answer, and argued in public."
  },
  {
    "key": "drama",
    "name": "Drama",
    "era": "classical",
    "requires": [
      "literacy",
      "priesthood"
    ],
    "description": "The festival rite becomes theatre, and the audience becomes a public."
  },
  {
    "key": "the_republic",
    "name": "The Republic",
    "era": "classical",
    "requires": [
      "code_of_laws",
      "literacy"
    ],
    "description": "Rule by elected magistrates, answerable to the citizens who chose them."
  },
  {
    "key": "engineering",
    "name": "Engineering",
    "era": "classical",
    "requires": [
      "construction",
      "surveying"
    ],
    "description": "Bridges, aqueducts and siege engines, designed rather than improvised."
  },
  {
    "key": "trade",
    "name": "Trade",
    "era": "classical",
    "requires": [
      "currency",
      "cartography",
      "literacy"
    ],
    "description": "Caravans and cargoes tying distant cities into one market."
  },
  {
    "key": "medicine",
    "name": "Medicine",
    "era": "classical",
    "requires": [
      "philosophy",
      "herbal_lore"
    ],
    "description": "Illness studied as nature rather than punishment, and treated accordingly."
  },
  {
    "key": "feudalism",
    "name": "Feudalism",
    "era": "medieval",
    "requires": [
      "kingship",
      "standing_army"
    ],
    "description": "Land granted for service: a lord's protection bought with a vassal's sword."
  },
  {
    "key": "monotheism",
    "name": "Monotheism",
    "era": "medieval",
    "requires": [
      "philosophy",
      "kingship"
    ],
    "description": "One god, one truth, and a church to keep it."
  },
  {
    "key": "scholasticism",
    "name": "Scholasticism",
    "era": "medieval",
    "requires": [
      "philosophy",
      "astronomy"
    ],
    "description": "Old texts gathered, reconciled and taught — the first universities."
  },
  {
    "key": "banking",
    "name": "Banking",
    "era": "medieval",
    "requires": [
      "trade",
      "the_republic"
    ],
    "description": "Money lent, deposits kept, bills of exchange honoured across borders."
  },
  {
    "key": "guilds",
    "name": "Guilds",
    "era": "medieval",
    "requires": [
      "trade",
      "feudalism"
    ],
    "description": "Crafts organised: apprentices, masters and standards of work."
  },
  {
    "key": "invention",
    "name": "Invention",
    "era": "medieval",
    "requires": [
      "engineering",
      "literacy"
    ],
    "description": "Gears, cams and escapements — machinery as a way of thinking."
  },
  {
    "key": "crop_rotation",
    "name": "Crop Rotation",
    "era": "medieval",
    "requires": [
      "irrigation",
      "feudalism"
    ],
    "description": "Fields rested in turn so the soil is never exhausted."
  },
  {
    "key": "fortification",
    "name": "Fortification",
    "era": "medieval",
    "requires": [
      "construction",
      "feudalism"
    ],
    "description": "Keeps, curtain walls and towers designed to be held by the few against the many."
  },
  {
    "key": "chivalry",
    "name": "Chivalry",
    "era": "medieval",
    "requires": [
      "feudalism",
      "horseback_riding"
    ],
    "description": "The mounted warrior in armour, bound by a code of conduct."
  },
  {
    "key": "theology",
    "name": "Theology",
    "era": "medieval",
    "requires": [
      "monotheism",
      "philosophy"
    ],
    "description": "Faith examined with the tools of reason."
  },
  {
    "key": "alchemy",
    "name": "Alchemy",
    "era": "medieval",
    "requires": [
      "scholasticism",
      "medicine"
    ],
    "description": "The search for the philosopher's stone, which found distillation instead."
  },
  {
    "key": "optics",
    "name": "Optics",
    "era": "medieval",
    "requires": [
      "scholasticism",
      "glassmaking"
    ],
    "description": "Lenses ground to correct eyes, and then to extend them."
  },
  {
    "key": "steel",
    "name": "Steel",
    "era": "medieval",
    "requires": [
      "iron_working",
      "invention"
    ],
    "description": "Iron made hard and supple at once."
  },
  {
    "key": "printing",
    "name": "Printing Press",
    "era": "renaissance",
    "requires": [
      "invention",
      "theology"
    ],
    "description": "Movable type: a thousand copies for the price of ten."
  },
  {
    "key": "gunpowder",
    "name": "Gunpowder",
    "era": "renaissance",
    "requires": [
      "invention",
      "alchemy"
    ],
    "description": "Saltpetre, charcoal and sulphur. Walls stop being enough."
  },
  {
    "key": "navigation",
    "name": "Navigation",
    "era": "renaissance",
    "requires": [
      "cartography",
      "optics"
    ],
    "description": "Compass, quadrant and log: position known in the open ocean."
  },
  {
    "key": "physics",
    "name": "Physics",
    "era": "renaissance",
    "requires": [
      "optics",
      "invention"
    ],
    "description": "Motion, force and falling bodies measured rather than assumed."
  },
  {
    "key": "heliocentrism",
    "name": "Heliocentrism",
    "era": "renaissance",
    "requires": [
      "astronomy",
      "physics"
    ],
    "description": "The earth moves. Everything else has to be rethought."
  },
  {
    "key": "economics",
    "name": "Economics",
    "era": "renaissance",
    "requires": [
      "banking",
      "printing"
    ],
    "description": "Markets studied as systems, and joint-stock ventures to exploit them."
  },
  {
    "key": "democracy",
    "name": "Democracy",
    "era": "renaissance",
    "requires": [
      "the_republic",
      "printing"
    ],
    "description": "Government by consent of the governed, argued in print."
  },
  {
    "key": "magnetism",
    "name": "Magnetism",
    "era": "renaissance",
    "requires": [
      "physics",
      "navigation"
    ],
    "description": "The lodestone understood, and the compass trusted."
  },
  {
    "key": "chemistry",
    "name": "Chemistry",
    "era": "renaissance",
    "requires": [
      "alchemy",
      "physics"
    ],
    "description": "Elements, compounds and reactions — alchemy with the magic removed."
  },
  {
    "key": "metallurgy",
    "name": "Metallurgy",
    "era": "renaissance",
    "requires": [
      "gunpowder",
      "steel"
    ],
    "description": "Cast cannon, rolled plate and the furnaces to make them."
  },
  {
    "key": "steam_power",
    "name": "Steam Power",
    "era": "industrial",
    "requires": [
      "physics",
      "metallurgy"
    ],
    "description": "Fire turned into motion. The first engine that does not tire."
  },
  {
    "key": "electricity",
    "name": "Electricity",
    "era": "industrial",
    "requires": [
      "magnetism",
      "metallurgy"
    ],
    "description": "A force caught in a jar, and then sent down a wire."
  },
  {
    "key": "rifling",
    "name": "Rifling",
    "era": "industrial",
    "requires": [
      "metallurgy",
      "democracy"
    ],
    "description": "Spiral-grooved barrels: accuracy at five times the range."
  },
  {
    "key": "atomic_theory",
    "name": "Atomic Theory",
    "era": "industrial",
    "requires": [
      "chemistry",
      "heliocentrism"
    ],
    "description": "Matter made of indivisible parts — which will turn out to be divisible."
  },
  {
    "key": "germ_theory",
    "name": "Germ Theory",
    "era": "industrial",
    "requires": [
      "chemistry",
      "medicine"
    ],
    "description": "Disease carried by organisms too small to see, and stopped by clean water."
  },
  {
    "key": "railway",
    "name": "Railway",
    "era": "industrial",
    "requires": [
      "steam_power",
      "surveying"
    ],
    "description": "Iron rails and steam locomotives: distance shrinks."
  },
  {
    "key": "telegraph",
    "name": "Telegraph",
    "era": "industrial",
    "requires": [
      "electricity",
      "railway"
    ],
    "description": "News along the line faster than any rider."
  },
  {
    "key": "industrialisation",
    "name": "Industrialisation",
    "era": "industrial",
    "requires": [
      "railway",
      "economics"
    ],
    "description": "The factory, the mill and the town that grows around them."
  },
  {
    "key": "the_corporation",
    "name": "The Corporation",
    "era": "industrial",
    "requires": [
      "industrialisation",
      "economics"
    ],
    "description": "Enterprise owned by shareholders and outliving its founders."
  },
  {
    "key": "refining",
    "name": "Refining",
    "era": "industrial",
    "requires": [
      "chemistry",
      "the_corporation"
    ],
    "description": "Crude oil split into fuels, lubricants and a hundred products."
  },
  {
    "key": "electronics",
    "name": "Electronics",
    "era": "modern",
    "requires": [
      "electricity",
      "the_corporation"
    ],
    "description": "The vacuum tube: current controlled by current."
  },
  {
    "key": "combustion",
    "name": "Combustion",
    "era": "modern",
    "requires": [
      "refining",
      "steam_power"
    ],
    "description": "The engine inside the cylinder: light, powerful and portable."
  },
  {
    "key": "flight",
    "name": "Flight",
    "era": "modern",
    "requires": [
      "combustion",
      "heliocentrism"
    ],
    "description": "Heavier than air, and off the ground."
  },
  {
    "key": "radio",
    "name": "Radio",
    "era": "modern",
    "requires": [
      "telegraph",
      "electronics",
      "flight"
    ],
    "description": "Signals through the air to anyone with a receiver."
  },
  {
    "key": "mass_production",
    "name": "Mass Production",
    "era": "modern",
    "requires": [
      "the_corporation",
      "combustion"
    ],
    "description": "The moving assembly line: identical goods by the million."
  },
  {
    "key": "nuclear_fission",
    "name": "Nuclear Fission",
    "era": "modern",
    "requires": [
      "atomic_theory",
      "mass_production"
    ],
    "description": "The atom split, and the energy inside it released."
  },
  {
    "key": "computers",
    "name": "Computers",
    "era": "modern",
    "requires": [
      "electronics",
      "mass_production"
    ],
    "description": "Machines that calculate, and then machines that decide."
  },
  {
    "key": "rocketry",
    "name": "Rocketry",
    "era": "modern",
    "requires": [
      "flight",
      "computers"
    ],
    "description": "Thrust enough to leave the atmosphere behind."
  },
  {
    "key": "genetics",
    "name": "Genetics",
    "era": "modern",
    "requires": [
      "germ_theory",
      "computers"
    ],
    "description": "The code of life read, and then edited."
  },
  {
    "key": "space_flight",
    "name": "Space Flight",
    "era": "modern",
    "requires": [
      "rocketry",
      "nuclear_fission"
    ],
    "description": "A people that can leave its world."
  }
]
